import React from 'react';
import PropTypes from 'prop-types';
import { ProjectPropTypes } from 'components/project/prop_types';
import { LeaseSpacesMediaPropTypes } from 'bundles/project/components/media_tab/media_props_types';
import LeaseSpaceRow from './lease_space_row';

export default function LeaseSpacesMedia({
  leaseSpacesMedia,
  project,
  syndication,
  visualMediaTypeOptions,
  onPhotoChange,
  onMediaLinksChange,
  onVisualMediaChange,
}) {
  return (
    <div className="d-flex flex-column gap-4">
      <h6>Lease Spaces</h6>
      {project.leaseSpaceListings.map((leaseListing, index) => {
        const leaseData = leaseSpacesMedia.find(item => item.id === leaseListing.leaseSpace.id);

        return (
          <LeaseSpaceRow
            index={index}
            key={leaseListing.id}
            leaseData={leaseData}
            leaseListing={leaseListing}
            project={project}
            syndication={syndication}
            visualMediaTypeOptions={visualMediaTypeOptions}
            onMediaLinksChange={onMediaLinksChange}
            onPhotoChange={onPhotoChange}
            onVisualMediaChange={onVisualMediaChange}
          />
        );
      })}
    </div>
  );
}

LeaseSpacesMedia.propTypes = {
  leaseSpacesMedia: LeaseSpacesMediaPropTypes,
  project: ProjectPropTypes.isRequired,
  syndication: PropTypes.bool.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onMediaLinksChange: PropTypes.func.isRequired,
  onPhotoChange: PropTypes.func.isRequired,
  onVisualMediaChange: PropTypes.func.isRequired,
};
